import { render, staticRenderFns } from "./IrrigationRecord.vue?vue&type=template&id=123e9bcc&scoped=true"
import script from "./IrrigationRecord.vue?vue&type=script&lang=js"
export * from "./IrrigationRecord.vue?vue&type=script&lang=js"
import style0 from "./IrrigationRecord.vue?vue&type=style&index=0&id=123e9bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123e9bcc",
  null
  
)

export default component.exports